var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField as MuiTextField } from '@mui/material';
import { Controller, useFormContext, } from 'react-hook-form';
var ERROR_ELEMENT_HIGHT = 1.4316;
export function TextField(_a) {
    var control = _a.control, name = _a.name, rules = _a.rules, label = _a.label, variant = _a.variant, watcher = _a.watcher, inputProps = _a.inputProps, _b = _a.ignoreInvalidValues, ignoreInvalidValues = _b === void 0 ? true : _b, _c = _a.hideError, hideError = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d, disableEnterKey = _a.disableEnterKey, render = _a.render, defaultValue = _a.defaultValue, rest = __rest(_a, ["control", "name", "rules", "label", "variant", "watcher", "inputProps", "ignoreInvalidValues", "hideError", "className", "disableEnterKey", "render", "defaultValue"]);
    var formContext = useFormContext();
    var contextControl = formContext === null || formContext === void 0 ? void 0 : formContext.control;
    var handleChange = function (onChange) { return function (event) {
        onChange(event.target.value);
        if (!watcher)
            return;
        watcher(event.target.value);
    }; };
    var onKeyDown = function (event) {
        if (disableEnterKey && event.key === 'Enter') {
            event.preventDefault();
        }
    };
    return (_jsx(Controller, { control: control || contextControl, rules: rules, name: name, defaultValue: defaultValue, render: render ? render : function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, _c = _a.fieldState, isTouched = _c.isTouched, isDirty = _c.isDirty, error = _c.error, formState = _a.formState;
            return (_jsx(MuiTextField, __assign({ onKeyDown: onKeyDown, error: !!error && !hideError, helperText: !hideError && (error === null || error === void 0 ? void 0 : error.message), onChange: handleChange(onChange), value: value || '', className: className, name: name, onBlur: onBlur, label: label, sx: {
                    marginBottom: error || hideError ? '0' : "".concat(ERROR_ELEMENT_HIGHT, "rem"),
                }, variant: variant, inputRef: ref, inputProps: inputProps }, rest)));
        } }));
}
export default TextField;
